import { render, staticRenderFns } from "./UserGroupAdmin.vue?vue&type=template&id=41f2df1e&"
import script from "./UserGroupAdmin.vue?vue&type=script&lang=js&"
export * from "./UserGroupAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports